import React from 'react';
import {observer} from "mobx-react";
import {useServices} from '../../../../../react-hooks/use-services.hook';
import {GameInfo} from '../../../../../services/games/game-info';
import {FlexGrowItemBox} from '../../../../../themes/architecture/css-helpers/flex';
import {
    VideoOverlayItemBox
} from '../../../../live-streaming-tile/video-common-components/video-overlay-item/video-overlay-item.box';
import {LiveStreamSlideStatusBadgeBox} from './boxes/status-badge/live-stream-slide-status-badge.box';
import {LiveStreamSlideStatusDetailsBox} from './boxes/status-details/live-stream-slide-status-details.box';
import {LiveStreamSlidePlayerContainer} from './boxes/live-stream-slide-player-container.box';
import {IVideoPlayerViewModel} from "../../../../../services/video/models/video-player.view-model.interface";
import {VideoPlayerComponent} from "../../../../video-player/video-player.component";
import {VideoSlidePlayerSkeletonBox} from "../../../parts/skeleton/video-slide-player-skeleton.box";
import {VideoTypeEnum} from "../../../../../services/video/models/video-type.enum";
import {LiveStreamSlideStatusIconBox} from './boxes/status-icon/live-stream-slide-status-icon.box';

interface LiveStreamSlidePlayerProps {
    gameInfo: GameInfo;
    videoPlayer: IVideoPlayerViewModel;
    isActive: boolean;
}
export const LiveStreamSlidePlayerComponent: React.FC<LiveStreamSlidePlayerProps> = observer((props) => {
    const services = useServices();



    const _renderTopLeft = () => {
        const _padding = "1rem";
        const RedRecordCircle = services.theme.currentTheme.icons.redRecordCircle;

        return (
            <VideoOverlayItemBox transparent style={{position: "absolute", top: _padding, left: _padding}}>
                <LiveStreamSlideStatusBadgeBox>
                    <LiveStreamSlideStatusIconBox>
                        <RedRecordCircle size={0.8}/>
                    </LiveStreamSlideStatusIconBox>
                    <LiveStreamSlideStatusDetailsBox>{services.translation.translate("VIDEO_SLIDES_LIVE_STREAMING")}</LiveStreamSlideStatusDetailsBox>
                </LiveStreamSlideStatusBadgeBox>
            </VideoOverlayItemBox>
        );
    }

    const showSkeleton = props.videoPlayer.isLoading && !props.videoPlayer.hasError;

    return (
        <>
            <FlexGrowItemBox/>
            {showSkeleton && <VideoSlidePlayerSkeletonBox />}
            <LiveStreamSlidePlayerContainer style={{display: showSkeleton ? 'none' : 'block'}}>
                <VideoPlayerComponent videoPlayer={props.videoPlayer}
                                      src={props.gameInfo.videoURL}
                                      isActive={props.isActive}
                                      videoType={VideoTypeEnum.LiveStream}
                                      poster={props.gameInfo.slideCover}/>
                {_renderTopLeft()}
            </LiveStreamSlidePlayerContainer>
            <FlexGrowItemBox/>
        </>
    )
});
